import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202603: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202603",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-03-01",
  endDate: "2026-03-31",
  impressions: 5718,
  clicks: 75,
  adsSpendDollars: 189,
  budgetDollars: 600,
  salesDollars: 932,
  bestEstimateRoas: 4.93,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.32,
  reorderConversions: 4,
  dataAvailableAtDate: "2026-04-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
